export var sidebarActions = {
    SHOW_SIDEBAR: 'SHOW_SIDEBAR',
    HIDE_SIDEBAR: 'HIDE_SIDEBAR',
};



//////////////////
// WEBPACK FOOTER
// ./src/actions/sidebarActions.ts
// module id = 89
// module chunks = 0